module.exports = __webpack_public_path__ + "img/service-and-shop-filter-kia.7c8dce9a.jpg";